module.exports = __webpack_public_path__ + "img/s04_03.cc8bd54e.jpg";